import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import { useTranslation } from "react-i18next";
import ContactHero from "@/pages/contact/components/ContactHero";
import ContactFormSection from "@/pages/contact/components/ContactFormSection";

export default function ContactDePage() {
  const { t } = useTranslation("home");

  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Kontaktieren Sie uns gerne | NetBasis International"
        description="Treten Sie mit uns in Kontakt. Wir unterstützen Sie verlässlich bei allen Fragen rund um Ihren Markteintritt in der DACH-Region."
        ogUrl="https://net-basis.net/de/kontakt"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <ContactHero />
        <ContactFormSection />

        {/* Bottom Claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              NetBasis International - drive to excellence with excellent drivers !
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}